// `entryPoint` parsing for `/live-chat?entryPoint=...` deeplinks. Kept
// free of `@leagueplatform/chat` imports so the Masonry deeplink handler
// can classify a URL without pulling in the chat SDK at bootstrap.
const KNOWN_ENTRY_POINTS = new Set(["ai", "human"]);

export function resolveCanonicalEntryPoint(
  raw: string | null
): "ai" | "human" | undefined {
  if (!raw) return undefined;
  if (KNOWN_ENTRY_POINTS.has(raw)) return raw as "ai" | "human";
  // Legacy alias — BE payloads emitted before the iOS-aligned `human`
  // value rolled out. Removing this alias needs a coordinated BE change.
  if (raw === "agent") return "human";
  return undefined;
}
